var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$lang === 'fr')?_c('NewFr',{staticClass:"badge"}):_c('NewEn',{staticClass:"badge"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }